import Typography from "@mui/material/Typography";

export type ExpiresAtDisplayProps = {
    value?: Date | null;
    variant?: "rich" | "simple";
};

export function ExpiresAtDisplay({ value, variant = "rich" }: ExpiresAtDisplayProps) {
    if (variant === "simple") {
        return (
            <Typography component="span">
                {value != null ? value.toLocaleDateString() : "—"}
            </Typography>
        );
    }

    if (value == null) {
        return (
            <Typography component="span" color="success.main">
                No expiry
            </Typography>
        );
    }

    const now = new Date();
    if (value < now) {
        return (
            <Typography component="span" color="error.main">
                Expired {value.toLocaleDateString()}
            </Typography>
        );
    }

    return (
        <Typography component="span" color="warning.main">
            Expires {value.toLocaleDateString()}
        </Typography>
    );
}

export type ShelfLifeDisplayProps = {
    value?: number | null;
    variant?: "rich" | "simple";
};

export function ShelfLifeDisplay({ value, variant = "rich" }: ShelfLifeDisplayProps) {
    if (variant === "simple") {
        return (
            <Typography component="span">
                {value != null && value > 0 ? `${value.toFixed(0)} days` : "—"}
            </Typography>
        );
    }

    if (value == null) {
        return (
            <Typography component="span" color="success.main">
                No shelf life
            </Typography>
        );
    }

    if (value < 0) {
        return (
            <Typography component="span" color="error.main">
                {value.toFixed(0)} days
            </Typography>
        );
    }

    return (
        <Typography component="span" color="warning.main">
            {value.toFixed(0)} days
        </Typography>
    );
}
